module.exports = __webpack_public_path__ + "f1bc6d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon_9ton_blue.png
// module id = 1543
// module chunks = 0